var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_70_1",
    "data-name": "Component 70 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.652,
    height: 39,
    viewBox: "0 0 46.652 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.652,
    height: 39,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.652,
    height: 38,
    rx: 4.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5881",
    "data-name": "Group 5881",
    transform: "translate(-1630.898 -552.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M634.839,233.7l-10.055,9.956a1.144,1.144,0,0,0-.34.813V246.9a1.157,1.157,0,0,0,1.222,1.149l2.285-.117a1.164,1.164,0,0,0,.761-.335l10.079-9.981a1.141,1.141,0,0,0,0-1.627l-2.308-2.286A1.17,1.17,0,0,0,634.839,233.7Z",
    transform: "translate(1020.773 333.988)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    d: "M1.178.016,4.427,0A1.143,1.143,0,0,1,5.578,1.151L5.562,4.4A1.17,1.17,0,0,1,4.4,5.562l-3.249.016A1.143,1.143,0,0,1,0,4.427L.016,1.178A1.17,1.17,0,0,1,1.178.016Z",
    transform: "translate(1660.879 562.446) rotate(44.996)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.ca394b7fbe1a6f6ffd8b991387063407.svg";
export { ForwardRef as ReactComponent };